import { render, staticRenderFns } from "./BookingsAssign.vue?vue&type=template&id=4ba2c734&"
import script from "./BookingsAssign.vue?vue&type=script&lang=js&"
export * from "./BookingsAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports